import gql from 'graphql-tag';

export const CLIENT_FRAGMENT = gql`
  fragment ClientFragment on ClientAccount {
    id
    companyEmail
    billingInfo {
      companyName
      contactName
      address1
      address2
      city
      state
      zip
      country
    }
    users {
      id
      firstName
      lastName
      email
      phone
    }
  }
`;
